import React, { useEffect, useRef, useState } from 'react';
import { Modal, Input, Button, App, Form, Select, Grid } from 'antd';
import { _T, Localization } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var RegistrationClassSource = models.registration.RegistrationClassSource;
var CompetitionRegistrationSource = models.registration.CompetitionRegistrationSource;
var DanceTeamSource = models.danceteams.DanceTeamSource;
var DanceTeamUsersSource = models.danceteams.DanceTeamUsersSource;
var UserDanceTeamSource = models.danceteams.UserDanceTeamSource;
var TeamSource = models.teams.TeamSource;
var UserItem = models.users.UserItem;
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { RegistrationTeamStatus } from '@vote4dance/judging-types';
import { DanceTeamUserNames } from '../../../../../base-react/components/DanceTeamUserNames';
import { DanceTeamEdit } from '../../../../../base-react/components/DanceTeamEdit';
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
import ImageUpload from '../../../../../base-react/components/ImageUpload';
const { Option } = Select;
const extractRegistrationImageId = (result) => {
    if (result == null) {
        return undefined;
    }
    if (typeof result === 'string' || typeof result === 'number') {
        return String(result);
    }
    if (result.team_image_id != null) {
        return String(result.team_image_id);
    }
    if (result.image_id != null) {
        return String(result.image_id);
    }
    if (result.registration_data) {
        try {
            const parsed = JSON.parse(result.registration_data);
            if ((parsed === null || parsed === void 0 ? void 0 : parsed.team_image_id) != null) {
                return String(parsed.team_image_id);
            }
        }
        catch {
            return undefined;
        }
    }
    return undefined;
};
export const RegistrationTeamEdit = (props) => {
    var _a;
    const { event_id, competition_id, registration_period_id, item, disabled, allowClassChange = true, openOnMount = false, hideTriggerButton = false, onClose, allowCancel = false, } = props;
    const [classes, loadingClasses] = Stream(RegistrationClassSource(competition_id, registration_period_id));
    const [teams] = Stream(item ? TeamSource(competition_id) : undefined);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const { notification } = App.useApp();
    const screens = Grid.useBreakpoint();
    const [searchResult, setSearchResult] = useState();
    const [danceTeams, setDanceTeams] = useState([]);
    const [inputEmail, setInputEmail] = useState('');
    const inputRef = useRef(null);
    const [submittable, setSubmittable] = useState(false);
    const [firstUserCountry, setFirstUserCountry] = useState('');
    const [creatorKey, setCreatorKey] = useState(0);
    const [pendingTeamImage, setPendingTeamImage] = useState(undefined);
    const searchedParticipant = searchResult
        ? {
            user_id: searchResult.user_id,
            user_firstname: searchResult.user_firstname,
            user_lastname: searchResult.user_lastname,
            user_image: searchResult.user_image,
            user_country: searchResult.user_country
        }
        : undefined;
    const values = Form.useWatch([], form);
    useEffect(() => {
        if (form)
            form.resetFields();
    }, []);
    useEffect(() => {
        if (form && item) {
            const newValues = getDefaultValue();
            if (form.getFieldsValue() != newValues) {
                form.setFieldsValue(newValues);
            }
        }
        setPendingTeamImage(undefined);
    }, [item, allowClassChange]);
    useEffect(() => {
        form
            .validateFields({ validateOnly: true })
            .then(() => setSubmittable(true))
            .catch(() => setSubmittable(false));
    }, [form, values]);
    // DEFAULTS (parse registration_data, keep same class as selected)
    const getDefaultValue = () => ({
        ...item,
        ...(item && item.registration_data) ? JSON.parse(item.registration_data) : { team_start_number: null },
        destination_class_id: item ? item.class_id : undefined
    });
    // Prefill + remember first user's country for edit mode
    useEffect(() => {
        if (!(item === null || item === void 0 ? void 0 : item.dance_team_id))
            return;
        const existing = item.registration_data ? JSON.parse(item.registration_data) : {};
        if (existing.team_country) {
            form.setFieldValue('team_country', existing.team_country);
        }
        (async () => {
            try {
                const users = await Api.read(DanceTeamUsersSource(item.dance_team_id).url);
                const country = (users === null || users === void 0 ? void 0 : users.length) > 0 ? users[0].user_country : '';
                setFirstUserCountry(country || '');
                const current = form.getFieldValue('team_country');
                if (!existing.team_country && !current && country) {
                    form.setFieldValue('team_country', country);
                }
            }
            catch {
                setFirstUserCountry('');
            }
        })();
    }, [item, form]);
    const openModal = () => {
        setPendingTeamImage(undefined);
        if (!item) {
            resetFields();
        }
        setVisible(true);
        if (item) {
            setTimeout(() => {
                var _a;
                (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 10);
        }
        if (form && item) {
            form.setFieldsValue(getDefaultValue());
        }
    };
    // 🔔 Auto-open when requested (e.g., pressing "Edit" in the table)
    useEffect(() => {
        if (openOnMount && !visible) {
            openModal();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openOnMount]);
    const handleCancel = () => {
        resetFields();
        setIsLoading(false);
        setVisible(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    const handleDanceTeamCreated = (team) => {
        setDanceTeams(prev => [team, ...prev]);
        form.setFieldsValue({ dance_team_id: team.dance_team_id });
    };
    const resetFields = () => {
        setInputEmail('');
        setSearchResult(undefined);
        setDanceTeams([]);
        setCreatorKey(prev => prev + 1);
        setPendingTeamImage(undefined);
        if (form) {
            form.resetFields();
        }
    };
    const normalizeEmpty = (v) => v === undefined || v === null || (typeof v === 'string' && v.trim() === '') ? undefined : v;
    const manualTeamFields = ['team_show_name', 'team_org', 'team_org_full', 'team_name'];
    const managerOverride = true;
    const paidOptions = [
        { label: _T('common.no'), value: 0 },
        { label: _T('common.yes'), value: 1 }
    ];
    const canCancelRegistration = (team) => !!team && [RegistrationTeamStatus.Created, RegistrationTeamStatus.Signed, RegistrationTeamStatus.Approved].includes(team.registration_status);
    const cancelRegistration = async (done) => {
        if (!item)
            return;
        setIsLoading(true);
        try {
            await Api.call(`${CompetitionRegistrationSource(competition_id).url}`, 'status', {
                dance_team_id: item.dance_team_id,
                class_id: item.class_id,
                status: RegistrationTeamStatus.Cancelled
            });
            notification.success({
                message: _T('common.cancel.success', { name: _T('registration.title').toLowerCase() })
            });
            handleCancel();
        }
        catch (err) {
            notification.error({
                message: (err.response && err.response.message) ? _T(err.response.message) : err.message
            });
            setIsLoading(false);
        }
        finally {
            done === null || done === void 0 ? void 0 : done();
        }
    };
    const onFinish = async (fieldsValue) => {
        var _a;
        setIsLoading(true);
        if (item) {
            // ---- EDIT FLOW (assign/move) ----
            const dest = allowClassChange
                ? ((_a = fieldsValue['destination_class_id']) !== null && _a !== void 0 ? _a : item.class_id)
                : item.class_id;
            const updateItem = {
                competition_id,
                dance_team_id: item.dance_team_id,
                class_id: item.class_id, // source
                destination_class_id: dest, // can be same as source
                registration_payment_done: fieldsValue['registration_payment_done'],
                managerOverride
            };
            // Build next registration_data (support clears)
            const existingData = item.registration_data ? JSON.parse(item.registration_data) : {};
            const nextData = { ...existingData };
            if (Object.prototype.hasOwnProperty.call(fieldsValue, 'team_start_number')) {
                const v = normalizeEmpty(fieldsValue['team_start_number']);
                if (v === undefined)
                    delete nextData.team_start_number;
                else
                    nextData.team_start_number = v;
            }
            if (Object.prototype.hasOwnProperty.call(fieldsValue, 'team_country')) {
                const v = normalizeEmpty(fieldsValue['team_country']);
                if (v === undefined) {
                    delete nextData.team_country;
                }
                else if (String(v) === String(firstUserCountry)) {
                    delete nextData.team_country; // don't persist if same as first user
                }
                else {
                    nextData.team_country = v;
                }
            }
            manualTeamFields.forEach((fieldName) => {
                if (Object.prototype.hasOwnProperty.call(fieldsValue, fieldName)) {
                    const value = normalizeEmpty(fieldsValue[fieldName]);
                    if (value === undefined) {
                        delete nextData[fieldName];
                    }
                    else {
                        nextData[fieldName] = value;
                    }
                }
            });
            const linkedTeam = teams === null || teams === void 0 ? void 0 : teams.find((team) => team.dance_team_id === item.dance_team_id && team.class_id === item.class_id);
            let nextTeamImageId = normalizeEmpty(form.getFieldValue('team_image_id'));
            if (pendingTeamImage !== undefined) {
                if (!item.dance_team_id) {
                    notification.error({
                        message: _T('common.error')
                    });
                    setIsLoading(false);
                    return;
                }
                try {
                    const pictureResult = await Api.call(`${DanceTeamSource().url}/${item.dance_team_id}`, 'set-picture', {
                        picture: pendingTeamImage
                    });
                    const imageId = extractRegistrationImageId(pictureResult);
                    if (pendingTeamImage !== null && !imageId) {
                        notification.error({
                            message: _T('common.error')
                        });
                        setIsLoading(false);
                        return;
                    }
                    nextTeamImageId = imageId;
                    form.setFieldValue('team_image_id', imageId);
                }
                catch (err) {
                    notification.error({
                        message: (err.response && err.response.message) ? _T(err.response.message) : err.message
                    });
                    setIsLoading(false);
                    return;
                }
            }
            if (nextTeamImageId === undefined && (linkedTeam === null || linkedTeam === void 0 ? void 0 : linkedTeam.team_image_id) && existingData.team_image_id === undefined) {
                nextTeamImageId = String(linkedTeam.team_image_id);
            }
            if (nextTeamImageId === undefined) {
                delete nextData.team_image_id;
            }
            else {
                nextData.team_image_id = nextTeamImageId;
            }
            const changed = JSON.stringify(existingData) !== JSON.stringify(nextData);
            if (changed) {
                updateItem.registration_data = JSON.stringify(nextData);
            }
            Api.call(`${CompetitionRegistrationSource(competition_id).url}`, 'assign', updateItem)
                .then(async () => {
                handleCancel();
            })
                .catch((err) => {
                notification.error({
                    message: (err.response && err.response.message) ? _T(err.response.message) : err.message
                });
                setIsLoading(false);
            });
        }
        else {
            // ---- CREATE FLOW (manual add) ----
            if (fieldsValue['user_id'] && !fieldsValue['dance_team_id']) {
                const danceTeamItem = {
                    users: [{ user_id: fieldsValue['user_id'] }],
                    competition_id
                };
                await Api.create(DanceTeamSource().url, danceTeamItem)
                    .then((result) => {
                    fieldsValue['dance_team_id'] = result.dance_team_id;
                })
                    .catch((err) => {
                    setIsLoading(false);
                    notification.error({
                        message: err.response && err.response.message ? _T(err.response.message) : err.message
                    });
                });
                if (!fieldsValue['dance_team_id'])
                    return;
            }
            const registerList = fieldsValue['team_starting_in'].map((class_id) => {
                // Build registration_data minimally; support clear if empty inputs (then null)
                const regData = {};
                const startNum = normalizeEmpty(fieldsValue['team_start_number']);
                const country = normalizeEmpty(fieldsValue['team_country']);
                if (startNum !== undefined)
                    regData.team_start_number = startNum;
                if (country !== undefined)
                    regData.team_country = country;
                manualTeamFields.forEach((fieldName) => {
                    const value = normalizeEmpty(fieldsValue[fieldName]);
                    if (value !== undefined) {
                        regData[fieldName] = value;
                    }
                });
                return {
                    ...fieldsValue,
                    competition_id,
                    class_id,
                    registration_period_id,
                    registration_data: Object.keys(regData).length > 0 ? JSON.stringify(regData) : null
                };
            });
            Api.call(`${CompetitionRegistrationSource(competition_id).url}`, 'register', {
                list: registerList,
                managerOverride,
                paidOverride: fieldsValue['registration_payment_done']
            })
                .then(async (result) => {
                if (result.warning && result.warning.length > 0) {
                    notification.error({
                        message: _T(result.warning[0].registration_warning)
                    });
                    setIsLoading(false);
                }
                else {
                    handleCancel();
                }
            })
                .catch((err) => {
                notification.error({
                    message: (err.response && err.response.message) ? _T(err.response.message) : err.message
                });
                setIsLoading(false);
            });
        }
    };
    const searchEmail = async (input) => {
        if (input.length <= 3)
            return;
        setIsSearching(true);
        await Api.call(DanceTeamSource().url, 'search-user', { term: input })
            .then((sr) => {
            return Promise.all([Api.read(UserDanceTeamSource(sr.user_id).url), sr]);
        })
            .then(([teams, sr]) => {
            if (teams && teams.length > 0) {
                setDanceTeams(teams);
                form.setFieldValue('dance_team_id', teams[0].dance_team_id);
            }
            else {
                setDanceTeams([]);
                form.setFieldValue('user_id', sr.user_id);
            }
            setSearchResult(sr);
        })
            .catch((err) => {
            setDanceTeams([]);
            setSearchResult(undefined);
            notification.error({
                message: (err.response && err.response.message) ? _T(err.response.message) : err.message
            });
        });
        setIsSearching(false);
    };
    const formName = item ? `registration_${item.dance_team_id}_${item.class_id}_item_settings` : `registration_new_${event_id}_item_settings`;
    const showTriggerText = !screens.xs;
    const linkedTeam = item
        ? teams === null || teams === void 0 ? void 0 : teams.find((team) => team.dance_team_id === item.dance_team_id && team.class_id === item.class_id)
        : undefined;
    return (React.createElement(React.Fragment, null,
        !hideTriggerButton && (React.createElement(Button, { icon: item ? React.createElement(EditOutlined, null) : React.createElement(PlusOutlined, null), onClick: openModal, disabled: disabled }, showTriggerText
            ? _T(item ? 'common.edit' : 'common.add', { name: _T('registration.title').toLowerCase() })
            : null)),
        React.createElement(Modal, { title: _T(item ? 'common.edit' : 'common.add', { name: _T('registration.title').toLowerCase() }), open: visible, width: 700, onCancel: handleCancel, footer: [
                item && allowCancel ? (React.createElement(ButtonConfirm, { key: "cancel-registration", title: _T('common.cancel.title', { name: _T('registration.title').toLowerCase() }), description: _T('common.cancel.content', { name: _T('registration.title').toLowerCase() }), disabled: !canCancelRegistration(item) || isLoading || disabled, onConfirm: cancelRegistration, buttonProps: {
                        danger: true
                    } })) : null,
                React.createElement(Button, { key: "modal-cancel", onClick: handleCancel }, _T('common.cancel.title')),
                React.createElement(Button, { key: "modal-ok", type: "primary", loading: isLoading, disabled: isLoading || disabled || !submittable, onClick: () => form.submit() }, _T('common.ok'))
            ] },
            React.createElement(Form, { name: formName, labelCol: { span: 8 }, wrapperCol: { span: 16 }, form: form, disabled: isLoading || disabled, onFinish: onFinish, initialValues: getDefaultValue(), style: { width: '100%' } },
                !item &&
                    React.createElement(Form.Item, { label: _T('users.email'), rules: [{ required: true, message: _T('common.required') }], name: "email" },
                        React.createElement(Input.Search, { placeholder: _T('common.search', { name: _T('users.email').toLowerCase() }), allowClear: true, type: 'email', autoFocus: true, enterButton: _T('common.search'), loading: isSearching, onSearch: text => searchEmail(text), onPressEnter: () => searchEmail(inputEmail), value: inputEmail, onChange: (e) => setInputEmail(e.target.value), onBlur: () => searchEmail(inputEmail) })),
                searchResult && !danceTeams.length ?
                    React.createElement(Form.Item, { label: _T('team.title'), name: "user_id", rules: [{ required: true, message: _T('common.required') }], hidden: danceTeams && danceTeams.length > 0 },
                        React.createElement(Select, null,
                            React.createElement(Option, { value: searchResult.user_id, key: searchResult.user_id }, UserItem.getFullName(searchResult))))
                    :
                        React.createElement(Form.Item, { label: _T('team.title'), name: "dance_team_id", rules: [{ required: danceTeams && danceTeams.length > 0, message: _T('common.required') }], hidden: !danceTeams || danceTeams.length === 0 },
                            React.createElement(Select, null, danceTeams && danceTeams.map((a, index) => (React.createElement(Option, { value: a.dance_team_id, key: index },
                                React.createElement(DanceTeamUserNames, { item: a })))))),
                !item &&
                    React.createElement(Form.Item, { label: " ", colon: false },
                        React.createElement(DanceTeamEdit, { key: `creator-${creatorKey}`, onCreate: handleDanceTeamCreated, buttonProps: {
                                type: 'dashed',
                                icon: React.createElement(PlusOutlined, null),
                                disabled: isLoading || disabled
                            }, autoIncludeCurrentUser: searchedParticipant || false })),
                !item &&
                    React.createElement(Form.Item, { label: _T('team.details.team_starting_in.label'), name: "team_starting_in", rules: [{ required: true, message: _T('team.details.team_starting_in.rule') }] },
                        React.createElement(Select, { mode: "multiple", allowClear: true, loading: loadingClasses, placeholder: _T('team.details.team_starting_in.placeholder') }, classes && classes.map((a, index) => (React.createElement(Option, { value: a.class_id, key: index }, a.class_label ? a.class_label : a.class_name))))),
                item && allowClassChange &&
                    React.createElement(Form.Item, { label: _T('team.details.team_starting_in.label'), name: "destination_class_id", rules: [{ required: true, message: _T('team.details.team_starting_in.rule') }] },
                        React.createElement(Select, { allowClear: true, loading: loadingClasses, placeholder: _T('team.details.team_starting_in.placeholder') }, classes && classes.map((a, index) => (React.createElement(Option, { value: a.class_id, key: index }, a.class_label ? a.class_label : a.class_name))))),
                React.createElement(Form.Item, { label: _T('registration.payment'), name: "registration_payment_done", initialValue: (_a = item === null || item === void 0 ? void 0 : item.registration_payment_done) !== null && _a !== void 0 ? _a : 0 },
                    React.createElement(Select, { options: paidOptions })),
                React.createElement(Form.Item, { label: _T('team.details.team_country.label'), name: "team_country" },
                    React.createElement(Select, { allowClear: true, showSearch: true, optionFilterProp: "label", options: Object.keys(Localization.getCountryNames()).map((code) => ({
                            value: code,
                            label: Localization.getCountryName(code)
                        })), placeholder: _T('team.details.team_country.placeholder') })),
                React.createElement(Form.Item, { label: _T('team.details.team_start_number.label'), name: "team_start_number" },
                    React.createElement(Input, { allowClear: true, ref: inputRef })),
                manualTeamFields.map((field) => (React.createElement(Form.Item, { key: field, label: _T(`team.details.${field}.label`), extra: _T(`team.details.${field}.extra` || ''), name: field },
                    React.createElement(Input, { allowClear: true })))),
                item &&
                    React.createElement(Form.Item, { label: _T('common.image') },
                        React.createElement(ImageUpload, { value: form.getFieldValue('team_image_id')
                                ? String(form.getFieldValue('team_image_id'))
                                : ((linkedTeam === null || linkedTeam === void 0 ? void 0 : linkedTeam.team_image_id) ? String(linkedTeam.team_image_id) : undefined), disabled: isLoading || disabled || !item.dance_team_id, onChange: (imageData) => {
                                setPendingTeamImage(imageData);
                                if (imageData == null) {
                                    form.setFieldValue('team_image_id', undefined);
                                }
                            } }))))));
};
